import type {BootstrapIconsId} from "bootstrap-icons";

export type BootstrapIconClass<Icon extends BootstrapIconsId> = `bi-${Icon}`;

export function bootstrapIconClass<Icon extends BootstrapIconsId>(icon: Icon): BootstrapIconClass<Icon> {
  return `bi-${icon}`;
}
